import { render, staticRenderFns } from "./cabinet-ktru-requests-list.vue?vue&type=template&id=9ffe7a2c&"
import script from "./cabinet-ktru-requests-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-ktru-requests-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ffe7a2c')) {
      api.createRecord('9ffe7a2c', component.options)
    } else {
      api.reload('9ffe7a2c', component.options)
    }
    module.hot.accept("./cabinet-ktru-requests-list.vue?vue&type=template&id=9ffe7a2c&", function () {
      api.rerender('9ffe7a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/ktru/requests/cabinet-ktru-requests-list.vue"
export default component.exports